import React from 'react';
export default function answer(props){
    return (
        < >
            <div style={{marginLeft:'8px',marginRight:'8px'}} dangerouslySetInnerHTML={{__html: ' <h1 style="text-align:center;margin-top: 16pt" align="center">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:14.0000pt;">“网聚职工正能量争做吉林好网民”</span></b><b><span\n' +
                    '                style="color:#444444;font-weight:bold;font-size:14.0000pt;"></span></b>\n' +
                    '            </h1>\n' +
                    '            <h1 style="text-align:center;margin-top: 8px" align="center">\n' +
                    '                <b><span\n' +
                    '                    style="color:#444444;font-weight:bold;font-size:16.0000pt;"><span>网上知识问答主题活动开始啦！</span></span></b><b><span\n' +
                    '                style="color:#444444;font-weight:bold;font-size:16.0000pt;"></span></b>\n' +
                    '            </h1>\n' +
                    '            <p className="p" style="text-align:center;margin-top: 8px" align="center">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:12.5000pt;">10万元优惠券等你瓜分！</span></b><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p" style="text-align:center;" align="center">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span>\n' +
                    '            </p>\n' +
                    '            <p className="p" style="text-align:center;" align="center">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p" style="text-indent:21.0000pt;">\n' +
                    '                <span\n' +
                    '                    style="color:#444444;font-size:10.5000pt;"><span>为切实增强全市广大职工群众网络安全意识和防范能力，有效防止各类网络安全事件发生，市总工会、市委网信办联合开展</span>2021年“网聚职工正能量争做吉林好网民”网上知识问答主题活动。</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p" style="text-indent:21.0000pt;">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:10.5000pt;"><span>活动时间：</span></span></b><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">2021年12月</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:10.5000pt;"><span>参加对象：</span></span></b><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;"><span>吉林市广大职工群众</span></span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:10.5000pt;"><span>奖项设置：</span></span></b><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;"><span>奖项为</span>1元、2元、3元、5元智慧工会APP无门槛优惠券。</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <b><span className="15"\n' +
                    '                         style="color:#444444;font-weight:bold;font-size:10.5000pt;"><span>活动规则：</span></span></b><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span\n' +
                    '                    style="color:#444444;font-size:10.5000pt;">1.职工在智慧工会APP“有奖竞答”模块，参与趣味答题活动。答题可获得积分，参加抽奖。</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span\n' +
                    '                    style="color:#444444;font-size:10.5000pt;">2.题库每天更新6道题，用户每日有1次机会参与答题，每答对1题获得5积分，答错不扣分。</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span\n' +
                    '                    style="color:#444444;font-size:10.5000pt;">3.积分可参与抽奖，每次抽奖消耗10积分。</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p style="text-indent:21.0000pt;" className="p">\n' +
                    '                <span\n' +
                    '                    style="color:#444444;font-size:10.5000pt;">4.抽奖获得的优惠券可叠加使用，优惠券可以赠送给其他会员，优惠券有效期自发放之日起7日内有效，数量有限，先到先得哦！</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <p className="p">\n' +
                    '                <span style="color:#444444;font-size:10.5000pt;">&nbsp;</span><span\n' +
                    '                style="color:#444444;font-size:10.5000pt;"></span>\n' +
                    '            </p>\n' +
                    '            <h1 style="text-align:center;background:#FFFFFF;" align="center">\n' +
                    '                <b><span style="font-family:\'MS Gothic\';color:#444444;font-weight:bold;font-size:24.0000pt;"></span></b><b><span\n' +
                    '                style="color:#444444;font-weight:bold;font-size:24.0000pt;"></span></b>\n' +
                    '            </h1>\n' +
                    '            <p className="MsoNormal">\n' +
                    '                <span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>\n' +
                    '            </p>\n' +
                    '            <br/>'}}
                ></div>
        </>
    )
}
